import { createContext } from "react";
import TrackingStore from "./tracking.store";

export const AppContext = createContext(new TrackingStore());
